/* eslint-disable import/prefer-default-export */
import { DateTime } from 'luxon';

const current = DateTime.now();

export const payslips = [
  { month: current.minus({ month: 1 }).toFormat('MM/yyyy'), amount: 2536 },
  { month: current.minus({ month: 2 }).toFormat('MM/yyyy'), amount: 2300 },
  { month: current.minus({ month: 3 }).toFormat('MM/yyyy'), amount: 2300 },
  { month: current.minus({ month: 4 }).toFormat('MM/yyyy'), amount: 2300 },
  { month: current.minus({ month: 5 }).toFormat('MM/yyyy'), amount: 2300 },
  { month: current.minus({ month: 6 }).toFormat('MM/yyyy'), amount: 2300 },
  { month: current.minus({ month: 7 }).toFormat('MM/yyyy'), amount: 2300 },
  { month: current.minus({ month: 8 }).toFormat('MM/yyyy'), amount: 2300 },
  { month: current.minus({ month: 9 }).toFormat('MM/yyyy'), amount: 2300 },
];
